// Keep route recognition independent of the lazy email-action page.
export function isEmailActionPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, "") === "/auth/action";
}
